import { useState } from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const Contact = () => {
  return (
    <>
      <ContactSection />
    </>
  );
};

export default Contact;

/* ---------------- Animations (kept for future framer-motion use) ---------------- */

const easeOut = [0.25, 0.1, 0.25, 1];

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: easeOut },
  },
};

const stagger = {
  visible: {
    transition: { staggerChildren: 0.15 },
  },
};

/* ---------------- Validation ---------------- */

const validate = (fields) => {
  const errors = {};

  if (!fields.name.trim()) {
    errors.name = "Name is required.";
  } else if (fields.name.trim().length < 2) {
    errors.name = "Name must be at least 2 characters.";
  }

  if (!fields.email.trim()) {
    errors.email = "Email is required.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email)) {
    errors.email = "Enter a valid email address.";
  }

  if (!fields.phone.trim()) {
    errors.phone = "Phone number is required.";
  } else if (!/^[+\d\s\-().]{7,15}$/.test(fields.phone)) {
    errors.phone = "Enter a valid phone number.";
  }

  if (!fields.message.trim()) {
    errors.message = "Message is required.";
  } else if (fields.message.trim().length < 10) {
    errors.message = "Message must be at least 10 characters.";
  }

  return errors;
};

/* ---------------- Section ---------------- */

const ContactSection = () => {
  const [fields, setFields] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");
  const [serverMessage, setServerMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: value }));

    // Clear the error for this field on change
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate(fields);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setStatus("loading");
    setServerMessage("");

    try {
      const formData = new FormData();
      formData.append("name", fields.name);
      formData.append("email", fields.email);
      formData.append("phone", fields.phone);
      formData.append("message", fields.message);

      const response = await fetch(
        "https://hotelsasthagrand.com/api/sendContact.php",
        {
          method: "POST",
          body: formData,
        },
      );

      const text = await response.text();
      let data = {};

      try {
        data = JSON.parse(text);
      } catch {
        data = {};
      }

      // ✅ FIXED CONDITION
      if (response.ok) {
        setStatus("success");
        setServerMessage(
          data.message || text || "Thank you! We'll get back to you soon.",
        );
        setFields({ name: "", email: "", phone: "", message: "" });
        setErrors({});
      } else {
        setStatus("error");
        setServerMessage(
          data.message || text || "Something went wrong. Please try again.",
        );
      }
    } catch (err) {
      setStatus("error");
      setServerMessage(
        "Network error. Please check your connection and try again.",
      );
    }
  };

  return (
    <section className="bg-[#FFFEF2] text-black p-5 md:p-20 relative overflow-hidden">
      <div className="mx-auto grid lg:grid-cols-[1fr_auto] gap-12">
        {/* Left Content */}
        <div>
          <span className="text-[20px] block mb-6 font-creto font-medium">
            Get Started
          </span>

          <h1 className="text-4xl md:text-[75px] lg:text-6xl max-w-3xl font-calson font-medium leading-tight mb-16">
            Get in touch with us. We're here to assist you.
          </h1>

          <form className="space-y-14" onSubmit={handleSubmit} noValidate>
            <div className="grid md:grid-cols-3 gap-10">
              <Input
                label="Your Name"
                name="name"
                value={fields.name}
                onChange={handleChange}
                error={errors.name}
              />
              <Input
                label="Email Address"
                name="email"
                type="email"
                value={fields.email}
                onChange={handleChange}
                error={errors.email}
              />
              <Input
                label="Phone Number"
                name="phone"
                type="tel"
                value={fields.phone}
                onChange={handleChange}
                error={errors.phone}
              />
            </div>

            <div>
              <Input
                label="Message"
                name="message"
                value={fields.message}
                onChange={handleChange}
                error={errors.message}
                isTextarea
              />
            </div>

            {/*  {status === "success" && (
              <div className="text-green-600 text-sm font-creto font-medium bg-green-50 border border-green-200 rounded-lg px-4 py-3">
                ✓ {serverMessage}
              </div>
            )}
            {status === "error" && (
              <div className="text-red-500 text-sm font-creto font-medium bg-red-50 border border-red-200 rounded-lg px-4 py-3">
                ✕ {serverMessage}
              </div>
            )} */}

            <div className="flex justify-end">
              <button
                type="submit"
                disabled={status === "loading"}
                className="bg-primary hover:bg-primary/80 disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer transition text-white px-8 py-4 font-creto rounded-full flex items-center gap-2 text-[16px] font-medium"
              >
                {status === "loading" ? (
                  <>
                    <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                    Sending...
                  </>
                ) : (
                  <>
                    Leave us a Message <span>→</span>
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

/* ---------------- Components ---------------- */

const Input = ({
  label,
  name,
  type = "text",
  value,
  onChange,
  error,
  isTextarea = false,
}) => (
  <div>
    <label className="block text-[20px] text-gray-500 mb-2 font-creto font-medium">
      {label}
    </label>
    {isTextarea ? (
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        rows={3}
        className={`w-full border-b ${
          error ? "border-red-400" : "border-gray-300 focus:border-black"
        } outline-none py-2 text-[20px] transition bg-transparent font-creto font-normal resize-none`}
      />
    ) : (
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        className={`w-full border-b ${
          error ? "border-red-400" : "border-gray-300 focus:border-black"
        } outline-none py-2 text-[20px] transition bg-transparent font-creto font-normal`}
      />
    )}
    {error && <p className="mt-1 text-xs text-red-500 font-creto">{error}</p>}
  </div>
);

const SocialIcon = ({ icon, link }) => (
  <a
    href={link}
    target="_blank"
    rel="noreferrer"
    className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center cursor-pointer hover:bg-primary hover:text-white transition"
  >
    {icon}
  </a>
);
